<template>
  <div class="h-screen w-full flex flex-col justify-center items-center">
    <h1 class="text-8xl mb-8">404 - PAGE NOT FOUND</h1>

    <router-link to="/"
      ><twelve-card border>Back Home</twelve-card></router-link
    >
  </div>
</template>
